// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 402) return "css/core.402.f3c3dde9e526213c4069.main.css";
	if (chunkId === 179) return "css/core.main.914629454ef686d96b10.main.css";
	// return url for filenames based on template
	return "css/core.chunk." + {"172":"bot","405":"cfd","654":"trader"}[chunkId] + "." + {"172":"81f8d511f52f690b21d2","405":"cfb87cbb7a7986ac66aa","654":"1480bd62448fadbceb08"}[chunkId] + ".css";
};